import React, { useState, useEffect } from 'react';
import RadioButton from '../../../../components/Dashboard-res/CommonComponent/RadioButton.js';
import get from 'lodash/get';
import { Form, useFormikContext } from 'formik';

import CommonInputWithIcon from '../../../../components/Dashboard-res/CommonComponent/CommonInputWithIcon.js';
import CommonDatePicker, {
  currentYear
} from '.././../../../components/Dashboard-res/CommonComponent/CommonDatePicker';
import Comments from '../CustomerDetails/Commments';
import ConvertNumberToWords from '../../../../common/constants/ConvertNumberToWords';
import './CustomerDetails.css';
import MaleImage from '../../../../images/icons/male.svg';
import Female from '../../../../images/icons/UserKycIcons/female_icon.svg';
import common_gender from '../../../../images/icons/UserKycIcons/common_gender.svg';
import { getLoanProduct } from '../../../../common/constants/api';
import PopUp from '../../../../common/components/PopUp/PopUp';

const SelectProduct = () => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    status,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    validateForm
  } = useFormikContext();
  const [words, setWords] = useState();
  const [show, setShow] = useState(false);
  const [products, setProducts] = useState([]);
  function onProductSelect(e) {
    setFieldValue('ProductId', e.target.value);
  }
  useEffect(() => {
    validateForm();
  }, [values.ProductId]);

  // Handlers
  const format = val => {
    if (val != NaN && val) {
      const repcomma = val.replace(/,/g, '');
      const convertNum = parseInt(repcomma);
      const res = convertNum
        .toFixed(1)
        .replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,')
        .toString()
        .split('.')[0];
      return res;
    }
  };
  const sanitize = val => {
    let formatedAmount;
    let checkAmount;
    if (val) {
      checkAmount = val.replace(/,/g, '');
    } else {
      setFieldValue('loanamount', '');
    }
    if (checkAmount <= 990000000) {
      formatedAmount = format(val);
      setFieldValue('loanamount', formatedAmount);
    }
  };
  useEffect(() => {
    setShow(true);
    getLoanProduct()
      .then(res => {
        setProducts(res);
        setShow(false);
      })
      .catch(err => {
        setShow(false);
        throw new Error(err?.response?.data?.message);
      });
  }, []);
  return (
    <div className="select_loan">
      <h2>Select Product</h2>
      <div className="mb-10">
        {products.map((data, index) => {
          return (
            <div className="row-auto flex mb-6 mt-6" key={data.id}>
              <RadioButton
                name="ProductId"
                id={`homeloan${data.id}`}
                value={data.id}
                checked={values.ProductId == data.id}
                onChange={e => {
                  handleChange(e);
                  onProductSelect(e);
                }}
                onBlur={e => {
                  handleBlur(e);
                }}
              />
              <label
                htmlFor="Home Loan"
                className="text-black-400 text-md text-right mt-0 ml-4"
              >
                {data.displayName}
              </label>
            </div>
          );
        })}
        <div className="text-red-300 mb-4">
          {touched.ProductId ? errors.ProductId : null}
        </div>
        <div className="loan_amount">
          <div className="grid_input_container mb-4">
            <div>
              <CommonInputWithIcon
                name="loanamount"
                id="loanamount"
                onChange={e => {
                  sanitize(e.target.value);
                  setWords(ConvertNumberToWords(e.target.value));
                }}
                onBlur={e => {
                  handleBlur(e);
                }}
                value={values.loanamount}
                stylesContainer={{
                  maxWidth: '100%',
                  marginBottom: '20px'
                }}
                legendName="Loan Amount"
                error={touched.loanamount && errors.loanamount}
                errorMsg={errors.loanamount}
                touched={touched.loanamount}
              />
              <p className="display_words mt-1 text-xs text-green-500">
                {words}
              </p>
            </div>
          </div>
        </div>

        <div className="DOB_field ">
          <div className="grid_input_container mb-8">
            <div className="text-black-600 font-roboto font-normal text-xs pb-2">
              DOB
            </div>
            <CommonDatePicker
              onChangeMonth={(value, isValidDate) => {
                setFieldValue('month', value, true);
                setFieldTouched('month', true, false);
                if (!isValidDate) {
                  setFieldValue(
                    'date',
                    {
                      value: '',
                      label: 'Date'
                    },
                    true
                  );
                }
              }}
              onChangeYear={(value, isValidDate) => {
                setFieldValue('year', value, true);
                setFieldTouched('year', true, false);

                if (!isValidDate) {
                  setFieldValue(
                    'date',
                    {
                      value: '',
                      label: 'Date'
                    },
                    true
                  );
                }
              }}
              onChangeDate={value => {
                setFieldValue('date', value, true);
                setFieldTouched('date', true, false);
              }}
              valueMonth={values.month}
              valueYear={values.year}
              valueDate={values.date}
              errorYear={touched.year && get(errors, 'year.value', false)}
              touchedYear={touched.year}
              onBlurYear={() => {
                setFieldTouched('year', true, true);
              }}
              errorMonth={touched.month && get(errors, 'month.value', false)}
              touchedMonth={touched.month}
              onBlurMonth={() => {
                setFieldTouched('month', true, true);
              }}
              // errors.date.value
              errorDate={touched.date && get(errors, 'date.value', false)}
              touchedDate={touched.date}
              onBlurDate={() => {
                setFieldTouched('date', true, true);
              }}
              errorMsg=""
              type="dob"
            />
          </div>
        </div>
        <div className="flex-1  w-full mb-8">
          <p className="font-roboto font-normal text-grey-920 text-base ">
            Gender
          </p>
          <div className={' w-full flex '}>
            <div
              className={values.gender == 'Male' ? 'assignedImg' : 'assignImg'}
              onClick={() => setFieldValue('gender', 'Male')}
            >
              <img className="cursor-pointer px-2 " src={MaleImage} />
            </div>
            <div
              className={
                values.gender == 'Female' ? 'assignedImg' : 'assignImg'
              }
              onClick={() => setFieldValue('gender', 'Female')}
            >
              <img className="cursor-pointer px-2" src={Female} />
            </div>
            <div
              className={
                values.gender == 'Unspecified' ? 'assignedImg' : 'assignImg'
              }
              onClick={() => setFieldValue('gender', 'Unspecified')}
            >
              <img className="cursor-pointer px-2" src={common_gender} />
            </div>
          </div>
          {errors.gender ? <p className="text-red-100 pt-2">Required</p> : null}
        </div>
        <Comments />
      </div>
      <PopUp
        type="loading"
        text="Fetching Loan Products..."
        setShow={setShow}
        show={show}
      />
    </div>
  );
};

export default SelectProduct;
